import React from 'react';

type Props = {
  dimension?: number;
};

const Icon: React.FC<Props> = ({  dimension = 16 }: Props) => (
  <svg width={dimension} height={dimension} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_29906_2978" maskUnits="userSpaceOnUse" x="0" y="0" width={dimension} height={dimension}>
      <rect width={dimension} height={dimension} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_29906_2978)">
      <path
        d="M2.66666 29.3332V5.33317C2.66666 4.59984 2.92777 3.97206 3.44999 3.44984C3.97221 2.92762 4.59999 2.6665 5.33332 2.6665H26.6667C27.4 2.6665 28.0278 2.92762 28.55 3.44984C29.0722 3.97206 29.3333 4.59984 29.3333 5.33317V21.3332C29.3333 22.0665 29.0722 22.6943 28.55 23.2165C28.0278 23.7387 27.4 23.9998 26.6667 23.9998H7.99999L2.66666 29.3332ZM6.86666 21.3332H26.6667V5.33317H5.33332V22.8332L6.86666 21.3332Z"
        fill="#018463"
      />
    </g>
  </svg>
);

export default Icon;
